import { FiBriefcase, FiHome, FiKey } from "react-icons/fi";
import { CgTrees } from "react-icons/cg";
import { BiShieldAlt2 } from "react-icons/bi";
import { GoRocket } from "react-icons/go";

// Re-export image-heavy data from propertyData for backwards compatibility.
// Pages that only need text data below won't trigger the image chunk
// until something else on the page imports from propertyData.
export {
  properties,
  review,
  teamdata,
  categoriesData,
  blogList,
  aboutData,
  agentData,
  agencyData,
} from "./propertyData";

export const featureData = [
  {
    icon: FiHome,
    title: "Land Acquisition",
    desc: "We identify and acquire prime mountain land parcels in Colorado's most desirable locations with exceptional views and development potential.",
  },
  {
    icon: FiBriefcase,
    title: "Engineering & Planning",
    desc: "Our team handles all engineering requirements, utility planning, and development permits to ensure your build site is ready for construction.",
  },
  {
    icon: FiKey,
    title: "Build Site Delivery",
    desc: "We deliver fully-prepared build sites with utilities, access roads, and all necessary infrastructure for your mountain dream home.",
  },
];

export const counterData = [
  {
    target: "140",
    title: "Acres Developed",
    sign: "+",
  },
  {
    target: "75",
    title: "Build Sites Delivered",
    sign: "+",
  },
  {
    target: "100",
    title: "Client Satisfaction",
    sign: "%",
  },
];

export const featureTwo = [
  {
    icon: "mdi mdi-cards-heart",
    title: "Comfortable",
    desc: "If the distribution of letters and words is random, the reader will not be distracted from making.",
  },
  {
    icon: "mdi mdi-shield-sun",
    title: "Extra Security",
    desc: "If the distribution of letters and words is random, the reader will not be distracted from making.",
  },
  {
    icon: "mdi mdi-star",
    title: "Luxury",
    desc: "If the distribution of letters and words is random, the reader will not be distracted from making.",
  },
  {
    icon: "mdi mdi-currency-usd",
    title: "Best Price",
    desc: "If the distribution of letters and words is random, the reader will not be distracted from making.",
  },
  {
    icon: "mdi mdi-map-marker",
    title: "Stratagic Location",
    desc: "If the distribution of letters and words is random, the reader will not be distracted from making.",
  },
  {
    icon: "mdi mdi-chart-arc",
    title: "Efficient",
    desc: "If the distribution of letters and words is random, the reader will not be distracted from making.",
  },
];

export const pricing = [
  {
    icon: CgTrees,
    title: "Basic",
    amount: "19",
    features: [
      "Full Access",
      "Source Files",
      "Free Appointments",
      "Enhanced Security",
    ],
  },
  {
    icon: BiShieldAlt2,
    title: "Premium",
    amount: "39",
    features: [
      "Full Access",
      "Source Files",
      "Free Appointments",
      "Enhanced Security",
    ],
  },
  {
    icon: GoRocket,
    title: "Business",
    amount: "99",
    features: [
      "Full Access",
      "Source Files",
      "Free Appointments",
      "Enhanced Security",
    ],
  },
];

export const accordionData = [
  {
    title: "How does it work ?",
    content:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    title: "Do I need a designer to use Hously ?",
    content:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    title: "What do I need to do to start selling ?",
    content:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    title: "What happens when I receive an order ?",
    content:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
];
